/*eslint-disable */
import Vue from "vue";

const url = 'wss://'+ process.env.VUE_APP_WEBSOCKET_BASE_URL + '/ws/video-call/';
let socket;

const emitter = new Vue({
  methods: {
    isOpen() {
      let status = '';
      if(socket && socket.readyState) {
        status = socket.readyState;
      }
      return status;
    },
    emit(message) {
      socket.send(JSON.stringify(message));
    },
    send(message) {
      if (1 === socket.readyState) socket.send(message);
    },
    close() {
      if (socket.readyState && 1 === socket.readyState) {
        emitter.$emit("close", JSON.stringify({message: 'Closing Chat', type: 'connectionClosed'}));
        socket.close();
        socket = null; // prevent memory leak
      }
    },
    connect(roomId) {
      socket = new WebSocket(url + roomId + "/");
      socket.onmessage = function(msg) {
        let message = JSON.parse(JSON.parse(msg.data).message);
        console.log(message);
        if(message.type === "joinRoom") {
          emitter.$emit("joinRoom", message);
        }
        else if(message.type === 'leftRoom') {
          emitter.$emit("leftRoom", message);
        }
        else if(message.type === 'offer') {
          emitter.$emit("offer", message);
        }
        else if(message.type === 'answer') {
          emitter.$emit("answer", message);
        }
        else if(message.type === 'screen-share') {
          emitter.$emit("screen-share", message);
        }
        else if(message.type === 'ice-candidate') {
          emitter.$emit("ice-candidate", message);
        }
        else if(message.type === 'videoStream') {
          emitter.$emit("videoStream", message);
        }
        else if(message.type === 'audioStream') {
          emitter.$emit("audioStream", message);
        }
        else if(message.type === 'roomFull') {
          emitter.$emit("roomFull", message);
        }
        else if(message.type === 'sessionCreated') {
          emitter.$emit("sessionCreated", message);
        }
      };
      socket.onopen = function(event) {
        emitter.$emit("open", event);
        emitter.$emit("connection", JSON.stringify({message: 'connection created successfully', type: 'connection'}));
      };
      socket.onclose = function (event) {
        console.log('The socket connection has been closed successfully');
      };
      socket.onerror = function(err) {
        emitter.$emit("error", err);
      };
    }
  }
});

export default emitter;
